import React, { useState } from "react";
import { unlock, flash } from "./lib";

export const EmailGate = ({ open, onUnlock }) => {
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const v = email.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return flash(setNote, "Enter a valid email first.");
    setBusy(true);
    try {
      await unlock(v);
    } catch (err) {
      console.error("unlock failed", err);
    }
    setBusy(false);
    onUnlock(v);
  };

  return (
    <div className={`email-gate ${open ? "" : "hidden"}`} data-testid="email-gate">
      <div className="gate-photo" style={{ backgroundImage: "url(/mm/sea.webp)" }} />
      <form className="gate-inner" onSubmit={submit} noValidate>
        <div className="label">Modern Mind</div>
        <h1 className="gate-title">Manifest</h1>
        <p className="gate-sub">Enter your email to access my manifestation method.</p>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="line-input text-center max-w-[360px] mx-auto block"
          data-testid="gate-email-input"
        />
        <button type="submit" className={`mono-btn app-btn mt-5 ${busy ? "sending" : ""}`} data-testid="gate-unlock-btn">
          {busy ? "Opening..." : "Enter"}
        </button>
        <div className="save-note" data-testid="gate-note">{note}</div>
      </form>
    </div>
  );
};
